import { ProjectFinancialsContractType } from 'api/project';
import { NonBillableHoursFlagSettingConfiguration } from 'api/timesheets/configuration/configuration';

export const isNonBillableHoursFlagEnabled = (
  financialContractType?: ProjectFinancialsContractType,
  nonBillableHoursFlagSetting?: NonBillableHoursFlagSettingConfiguration,
) => {
  if (
    nonBillableHoursFlagSetting === undefined ||
    financialContractType === undefined
  ) {
    return false;
  }
  switch (financialContractType) {
    case ProjectFinancialsContractType.FIXED:
      return nonBillableHoursFlagSetting.nonBillableHoursFlagForFixedFeeProjectsEnabled;
    case ProjectFinancialsContractType.TM:
      return nonBillableHoursFlagSetting.nonBillableHoursFlagForTimeAndMaterialProjectsEnabled;
    case ProjectFinancialsContractType.SUBSCRIPTION:
      return nonBillableHoursFlagSetting.nonBillableHoursFlagForSubscriptionProjectsEnabled;
    default:
      return false;
  }
};
